import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Modal, Input} from 'antd';
import {message} from './Mess'
import CmForm from "../../../components/CmForm/CmForm";
import {uuid} from "../../../utils";
import BaseComponent from "../../../base/BaseComponent";


export default class NewFolderModel extends BaseComponent {
    static defaultProps = {

        onClick: () => {

        },
        IsChecked:()=>{

        },
        getKey:{
            keyName:'newName',
            keyVirtualFileId:'virtualFileId',
        }
    };
    static propTypes = {

    };

    constructor(props) {
        super(props);
        this.state = {
            createStorageDirectoryModel: false,
            createStorageName:"",
            checkArray:[],
            IsDefault:'',
            suffix:'',
            IsTile:false,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.props.onRef(this)
    }
    show(refreshKey,data,currentId,checkArray,IsDefault,IsTile){
        if(IsDefault){
            this.setState({IsDefault:IsDefault})
        }
        //是不是检索模块  走的方法不一样
        if(IsTile){
            this.setState({IsTile:IsTile})
        }
        if(data){
            this.state.createStorageTitle= data;
            if(data === '新建文件夹'){
                this.setState({createStorageName:''})
            }else{
                if(checkArray.length){
                    this.state.checkArray = checkArray;
                    this.state.createStorageName =checkArray[0].name;
                    if(checkArray[0].fileTypeEnum ==='DIR'){
                        this.state.suffix =''
                    }else{
                        this.state.suffix =this.state.checkArray[0].suffix
                    }
                }
            }
        }
        if(currentId){
            this.state.currentId= currentId
        }
        this.state.createStorageDirectoryModel = true;
        this.setState({})

    }


    render() {
        let name =  this.state.createStorageName;
        if(this.state.createStorageTitle==='重命名'){
            if(this.state.suffix){
                if(this.state.createStorageName.indexOf(this.state.suffix)>-1){
                    this.state.createStorageName = name.substring(0, name.lastIndexOf("."));
                }
            }
        }
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return(

                <Modal
                    maskClosable={false}
                    keyboard={true}
                    title={this.state.createStorageTitle}
                    visible={this.state.createStorageDirectoryModel}
                    onOk={() => {
                        this.createStorageHandleOk()
                    }}
                    centered
                    width={400}
                    onCancel={() => {
                        this.setState({createStorageDirectoryModel: false})
                    }}
                >
                    <CmForm onSubmit={() => {
                        this.createStorageHandleOk()
                    }}>
                    <div>
                        <Input placeholder="请输入文件夹名称" maxLength={255} style={{width:this.state.createStorageTitle==='重命名'&&this.state.suffix?'87%':'100%',marginLeft:5}} value={this.state.createStorageName}  onChange={(e) => {
                         this.Stripscript(e.target.value)
                        }}/>
                        {this.state.createStorageTitle==='重命名'&&this.state.suffix?  <span style={{display:'inlineBlock',width:'10%',marginLeft:'1%'}}>{'.'+this.state.suffix}</span>:''}
                    </div>
                        <style>
                            {
                                `.ant-input:focus, .ant-input:hover {border-color:${newSecondSelectColor} !important}`
                            }
                        </style>
                    </CmForm>
                </Modal>
        )
    }


    Stripscript(s) {
        let pattern = new RegExp('[\/:*?"<>|&]')
        let  rs = "";
        for (var i = 0; i < s.length; i++) {
            rs = rs + s.substr(i, 1).replace(pattern, '');
        }
     this.setState({createStorageName:rs},()=>{
     })
    }
    createStorageHandleOk() {
        this.state.createStorageName = this.state.createStorageName.replace(/\s*/g,"");
        if(this.state.createStorageName){
            if (this.state.createStorageTitle === '新建文件夹') {
                let parms = {
                    name: this.state.createStorageName,
                    fid: this.state.currentId
                };
                //新建文件夹接口
                this.request({
                    url: "/cm-sites-storage-management/zykFile/mkdir",
                    method: "post",
                    body: parms,

                    callBack: (data) => {
                        message.success('操作成功');
                        this.setState({createStorageDirectoryModel: false}, () => {
                            // this.props.callBack&&this.props.callBack(this.props.currentId, this.props.current,[]);
                            this.props.callBack&&this.props.callBack()
                        })
                    }
                });
            }else{
                let name = this.state.createStorageName;
                if(name){
                    if(this.state.suffix){
                        name =  this.state.createStorageName +'.'+ this.state.suffix;
                    }
                    //检索模块的重命名
                    if(this.state.IsTile){
                        let parms = {
                            name: name,
                            thirdId: this.state.checkArray[0].id
                        };
                        this.request({
                            url: "/search-server/search/rename",
                            method: "post",
                            body: parms,
                            contentType:'json',
                            callBack: (data) => {
                                message.success('操作成功');
                                this.setState({createStorageDirectoryModel: false}, () => {
                                    // this.props.callBack&&this.props.callBack(this.props.currentId, this.props.current,[],true);
                                    this.props.callBack&&this.props.callBack()
                                })
                            }
                        });
                    }else{
                        //文件库模块的重命名
                        let getKey=this.props.getKey;
                        let parms = {
                            [getKey.keyName] :name,
                            [getKey.keyVirtualFileId]:this.state.IsDefault?this.state.checkArray[0].virtualFileId:this.state.checkArray[0].id
                        };
                        this.request({
                            url: "/cm-sites-storage-management/zykFile/rename", method: "post", body: parms, callBack: (data) => {
                                message.success('操作成功');
                                this.setState({createStorageDirectoryModel: false}, () => {
                                    setTimeout(()=>{
                                        this.props.callBack&&this.props.callBack()
                                        // this.props.callBack&&this.props.callBack(this.props.currentId, this.props.current,[],true);
                                    },300)

                                })
                            }
                        });
                    }
                }
           }
    }else{
            message.error('请填写文件夹名称！')
        }
}

}
